import { LocationOn, Phone, Email } from "@mui/icons-material";
import { Box, Grid, Typography, Stack, Link, Divider, useTheme } from "@mui/material";
import {
	COMPANY_NAME,
	COMPANY_ADDRESS,
	COMPANY_PHONES,
	COMPANY_EMAIL,
	COPYRIGHT_YEAR,
} from "../../constants/contact";

function Footer() {
	const theme = useTheme();
	const isDark = theme.palette.mode === "dark";

	return (
		<Box
			component="footer"
			sx={{
				background: isDark
					? "linear-gradient(135deg, #0a0f1a 0%, #131b2e 50%, #1a2744 100%)"
					: "linear-gradient(135deg, #092a44 0%, #0d3b5e 50%, #1a608e 100%)",
				color: "white",
				pt: 6,
				pb: 3,
				px: { xs: 3, md: 6 },
			}}
		>
			<Grid container spacing={4}>
				<Grid item size={{ xs: 12, md: 5 }}>
					<Typography variant="h5" fontWeight={700} gutterBottom>
						{COMPANY_NAME}
					</Typography>
					<Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)", maxWidth: 400 }}>
						A Canadian steel trading house supplying flat, tubular, and specialty
						steel products across North America, South America, and worldwide.
					</Typography>
				</Grid>
				<Grid item size={{ xs: 12, md: 3 }}>
					<Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 2 }}>
						Contact
					</Typography>
					<Stack spacing={1.5}>
						<Stack direction="row" alignItems="flex-start" spacing={1.5}>
							<LocationOn fontSize="small" aria-hidden="true" sx={{ color: "rgba(255,255,255,0.6)", mt: 0.3 }} />
							<Typography variant="body2" sx={{ color: "rgba(255,255,255,0.85)" }}>
								{COMPANY_ADDRESS.street}
								<br />
								{COMPANY_ADDRESS.city}, {COMPANY_ADDRESS.province}{" "}
								{COMPANY_ADDRESS.postalCode}
							</Typography>
						</Stack>
						{COMPANY_PHONES.map((phone) => (
							<Link 
								key={phone} 
								href={`tel:${phone}`} 
								underline="none" 
								sx={{ display: 'block' }} // Ensures the link behaves well within the layout
							>
								<Stack direction="row" alignItems="center" spacing={1.5}>
									<Phone fontSize="small" aria-hidden="true" sx={{ color: "rgba(255,255,255,0.6)" }} />
									<Typography 
										variant="body2" 
										sx={{ 
											color: "rgba(255,255,255,0.85)",
											textDecoration: "underline",
											textDecorationColor: "rgba(255,255,255,0.3)",
											'&:hover': { 
												color: '#fff' ,
												textDecorationColor: "#fff",
											} 
											
										}}
									>
										{phone}
									</Typography>
								</Stack>
							</Link>
						))}
						<Stack direction="row" alignItems="center" spacing={1.5}>
							<Email fontSize="small" aria-hidden="true" sx={{ color: "rgba(255,255,255,0.6)" }} />
							<Link
								href={`mailto:${COMPANY_EMAIL}`}
								sx={{ color: "rgba(255,255,255,0.85)", textDecorationColor: "rgba(255,255,255,0.3)", fontSize: "0.875rem" }}
							>
								{COMPANY_EMAIL}
							</Link>
						</Stack>
					</Stack>
				</Grid>
				<Grid item size={{ xs: 12, md: 4 }}>
					<Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 2 }}>
						Quick Links
					</Typography>
					<Stack spacing={1}>
						{[
							["Home", "/home"],
							["About Us", "/about-us"],
							["Tubular Products", "/products/tubular"],
							["Flat Products", "/products/flat"],
							["Other Products", "/products/other"],
						].map(([label, href]) => (
							<Link
								key={href}
								href={href}
								sx={{
									color: "rgba(255,255,255,0.75)",
									textDecoration: "none",
									fontSize: "0.875rem",
									"&:hover": { color: "white" },
									transition: "color 0.2s",
								}}
							>
								{label}
							</Link>
						))}
					</Stack>
				</Grid>
			</Grid>
			<Divider sx={{ borderColor: "rgba(255,255,255,0.12)", my: 3 }} />
			<Typography variant="body2" sx={{ color: "rgba(255,255,255,0.5)", textAlign: "center" }}>
				&copy; {COPYRIGHT_YEAR} {COMPANY_NAME}. All rights reserved.
			</Typography>
		</Box>
	);
}

export default Footer;
